import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';

import {
  auth,
  employer,
  fileDownload,
  lmsAnalytics,
  layoutConfig,
  navbarConfig,
  s3Upload,
  school,
  settings,
  sidebarConfig,
  sidebarMenuConfig,
  student,
  careerPreference,
  job,
  research,
  event,
  partnership,
  notifications,
  invite,
  testimonial,
  signUpRequest,
  program,
  payments,
  hire,
  credit,
  skills,
  comments,
  feedback,
  questions,
  likes,
  user,
  location,
  scholarships,
  blog,
  partner,
  organization,
  applicationForm,
  sections,
  uni,
  featureUpdates,
  resume,
  assessment,
  stories,
  gpts,
  emailSubscription,
  simulations,
  attendance,
  inquiries,
  advisors,
  aiSkills,
  skillsCompetitions,
  pathways,
  societies,
  tuTestimonials,
  courses,
  chapters,
  quizzes,
  lessons,
  assignments,
  courseEnrollments,
  gradedSubmissions,
  bulkMessaging,
  skillform,
  aiProviderConfig,
  testProvider,
  examResult,
  licenseVerification,
  emailConfig,
} from './modules';

Vue.use(Vuex);

export const state = () => ({
  brand: 'Transition',
});

export const createStore = () => {
  return new Vuex.Store({
    state,
    getters: { settings: state => state.settings.state },
    mutations: {},
    actions: {},
    modules: {
      settings,
      layoutConfig,
      sidebarConfig,
      sidebarMenuConfig,
      navbarConfig,
      auth,
      fileDownload,
      lmsAnalytics,
      s3Upload,
      school,
      student,
      employer,
      aiSkills,
      careerPreference,
      job,
      research,
      event,
      partnership,
      notifications,
      invite,
      testimonial,
      signUpRequest,
      program,
      payments,
      hire,
      credit,
      skills,
      comments,
      feedback,
      questions,
      likes,
      user,
      location,
      scholarships,
      blog,
      partner,
      organization,
      applicationForm,
      sections,
      uni,
      featureUpdates,
      resume,
      assessment,
      stories,
      gpts,
      emailSubscription,
      simulations,
      attendance,
      inquiries,
      advisors,
      skillsCompetitions,
      pathways,
      societies,
      tuTestimonials,
      courses,
      chapters,
      quizzes,
      lessons,
      assignments,
      courseEnrollments,
      gradedSubmissions,
      bulkMessaging,
      skillform,
      aiProviderConfig,
      testProvider,
      examResult,
      licenseVerification,
      emailConfig,
    },
    plugins: [createPersistedState({ paths: ['auth', 'student'] })],
  });
};

const store = createStore();
export default store;
